// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FT8dU","container":"Footer_container__x8-HX","bottom":"Footer_bottom__dt2LU","link":"Footer_link__GRSSp","creator":"Footer_creator__k29tu"};